<script>
  import { sum } from "d3";
  import charts from "../data/popup-charts.json";
  import copy from "../data/doc.json";

  export let show;

  const labelMap = {
    children_yes: "Yes",
    children_no: "No",
  };

  $: withValues = charts.map(({ name, cols, newCols }) => {
    cols = newCols ? newCols.map((n) => n[0]) : cols;
    const values = newCols
      ? newCols.map((n) => sum(n[1].map((c) => Math.round(+show[c]))))
      : cols.map((c) => Math.round(+show[c]));

    return {
      name,
      cols,
      values,
    };
  });

  $: hasData = !!withValues
    .map((d) => d.values.filter((v) => v).length)
    .filter((d) => d).length;
</script>

{#if hasData}
  <h4>Audience Demographics</h4>
  <div class="charts">
    {#each withValues as { name, cols, values }}
      <div class="chart">
        <p class="title">{name}</p>
        <figure>
          {#each cols as col, i}
            {#if values.filter((d) => d).length}
              <div>
                <p class="label">{labelMap[col] || col}</p>
                <div
                  class:little="{values[i] < 20}"
                  class="bar"
                  style="width: {values[i] || 0}%;"
                >
                  <span>{values[i]}%</span>
                </div>
              </div>
            {/if}
          {/each}
        </figure>
      </div>
    {/each}
  </div>
{:else}
  <p class="nodata">{@html copy.audienceNoData}</p>
{/if}

<style>
  .charts {
    display: flex;
    flex-wrap: wrap;
  }

  .chart {
    width: 50%;
    padding-right: 0.5em;
    margin-bottom: 2em;
  }

  .title {
    font-size: 14px;
    margin: 0;
    font-weight: bold;
  }

  .label {
    font-size: 12px;
    margin: 0;
    margin: 0.25em 0;
  }

  .bar {
    position: relative;
    background-color: var(--theme);
    height: 1em;
    line-height: 1em;
    margin-bottom: 0.5em;
  }

  .bar span {
    position: absolute;
    font-size: 12px;
    opacity: 1;
    top: 0;
    right: 0;
    margin-right: 0.5em;
    color: var(--base-white);
  }

  .bar.little span {
    right: auto;
    left: 100%;
    margin-left: 0.5em;
    color: var(--theme);
  }

  h4 {
    font-weight: bold;
    margin-top: 2em;
    text-transform: uppercase;
    font-size: 16px;
  }

  .nodata {
    font-size: 16px;
  }
</style>
